import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const StatusLabel = styled.span`
  font-size: ${themeGet('statusLabel.fontSize')};
  color: ${themeGet('statusLabel.color')};
  background-color: ${props => themeGet(`statusLabel.types.${props.type}`)(props)};
  max-width: ${themeGet('statusLabel.maxWidth')};
  border: ${themeGet('statusLabel.border')};
  border-radius: ${themeGet('statusLabel.borderRadius')};
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 24px;
  line-height: 24px;
  padding: 0 8px;
`;

StatusLabel.defaultProps = {
  type: 'info',
};
